export default __webpack_public_path__ + "static/media/ep4collage2.02da998b.jpg";